module.exports = __webpack_public_path__ + "img/icon1.80684ddd.svg";